import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { nav } from "@/business-config";
export function Wordmark() {
  return (
    <span className="wordmark" aria-hidden="true">
      <span className="wordmark-title">Imperial Cars</span>
      <span className="wordmark-meta">
        <span>Service auto</span>
        <small>A&amp;F</small>
      </span>
    </span>
  );
}
export default function Header({ basePath = "" }) {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const trigger = useRef(null);
  const navItems = basePath
    ? [
        { label: "Servicii", to: `${basePath}#servicii` },
        { label: "Cum lucrăm", to: `${basePath}#atelier` },
        { label: "Contact", to: `${basePath}#contact` },
      ]
    : nav;
  const homeTo = basePath || "/";
  const contactTo = basePath ? `${basePath}#contact` : "/#contact";
  const closeAfterNavigation = () => {
    setOpen(false);
  };
  useEffect(() => setOpen(false), [pathname, hash]);
  useEffect(() => {
    const close = (e) => {
      if (e.key === "Escape" && open) {
        setOpen(false);
        trigger.current?.focus();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open]);
  return (
    <header className="site-header">
      <div className="header-inner">
        <Link
          to={homeTo}
          className="brand"
          aria-label="Imperial Cars, pagina principală"
        >
          <Wordmark />
        </Link>
        <span className="header-location">
          Service auto
          <br />
          Târgu Mureș
        </span>
        <nav className="desktop-nav" aria-label="Navigație principală">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={closeAfterNavigation}
              className={hash && item.to.endsWith(hash) ? "active" : undefined}
              aria-current={hash && item.to.endsWith(hash) ? "location" : undefined}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <Link className="button header-book" to={contactTo} onClick={closeAfterNavigation}>
          Solicită o programare <ArrowUpRight size={17} />
        </Link>
        <button
          className="menu-toggle"
          ref={trigger}
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label={open ? "Închide meniul" : "Deschide meniul"}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <nav
          id="mobile-menu"
          className="mobile-nav"
          aria-label="Navigație mobilă"
        >
          {navItems.map((item) => (
            <Link key={item.to} to={item.to} onClick={closeAfterNavigation}>
              {item.label}
              <ArrowUpRight size={20} />
            </Link>
          ))}
          <Link to={contactTo} onClick={closeAfterNavigation}>
            Solicită o programare <ArrowUpRight size={20} />
          </Link>
        </nav>
      )}
    </header>
  );
}
